import { Component, OnInit, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import {ColDef, ColGroupDef, GridApi, GridOptions, RowDataUpdatedEvent} from 'ag-grid-community';
import { DelinquencyReport } from '../../../shared/common-components/common-structure';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-delinquency-report',
    templateUrl: './delinquency-report.component.html',
    styleUrls: ['./delinquency-report.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DelinquencyReportComponent implements OnInit, OnChanges {

  @Input() delinquencyReportColDefs: (ColDef | ColGroupDef)[];
  @Input() delinquencyReportData: Observable<DelinquencyReport[]>;
  @Input() delinquencyReportDefColDef: any;
  @Input() delinquencyReportTooltipShowDelay: any;
  @Input() delinquencyReportFrameworkComponents: any;
  @Input() title: string;
  private gridApi!: GridApi<any>;

  delinquencyReportGridOptions: GridOptions = this.initializeGridOptions();

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
  }


  initializeGridOptions(): GridOptions {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: false
        },
        tooltipComponent: 'cellRenderer',
        cellRenderer: 'iconRenderer'
      },
      suppressDragLeaveHidesColumns: true,
      headerHeight: 50,
      columnGroups: true,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      domLayout: 'autoHeight',
      onGridReady: params => {
        this.gridApi = params.api;
        params.api.sizeColumnsToFit();
      },
      onRowDataChanged: event => this.refreshColumnGroupHeader(event),
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
      overlayNoRowsTemplate:
        '<span>No results found. Please adjust your filters.</span>'
    };
  }

  private refreshColumnGroupHeader(event: RowDataUpdatedEvent) {
    if (!event.api.getDisplayedRowAtIndex(0)) {
      return;
    }
    const rowData = event.api.getDisplayedRowAtIndex(0)
      .data;
    event.columnApi.getAllDisplayedColumnGroups().forEach(cg => {
      const colDef = cg.getDefinition();
      switch (colDef.headerName) {
        case 'last4thQuarter':
          colDef.headerName = this.getQuarterDescriptionHeader(
            rowData.last4thQuarterCompleted
          );
          break;
        case 'last3rdQuarter':
          colDef.headerName = this.getQuarterDescriptionHeader(
            rowData.last3rdQuarterCompleted
          );
          break;
        case 'last2ndQuarter':
          colDef.headerName = this.getQuarterDescriptionHeader(
            rowData.last2ndQuarterCompleted
          );
          break;
        case 'last1stQuarter':
          colDef.headerName = this.getQuarterDescriptionHeader(
            rowData.last1stQuarterCompleted
          );
          break;
        default:
          break;
      }
    });
    event.api.refreshHeader();
  }

  private getQuarterDescriptionHeader(quarterHeader: string) {
    return quarterHeader.toUpperCase().indexOf('-1') > -1
      ? quarterHeader + ' Q1 (January - March)'
      : quarterHeader.toUpperCase().indexOf('-2') > -1
        ? quarterHeader + ' Q2 (April - June)'
        : quarterHeader.toUpperCase().indexOf('-3') > -1
          ? quarterHeader + ' Q3 (July - September)'
          : quarterHeader.toUpperCase().indexOf('-4') > -1
            ? quarterHeader + ' Q4 (October - December)'
            : '';
  }

  onExport() {
    this.gridApi.exportDataAsExcel({ allColumns: true, skipColumnGroupHeaders: false});
  }

}
